@if (showPage) {
  <div class="wrapper">
    <div class="container">
      <div class="container-fluid">
        <div class="card card-nobg full-card shadow-sm m-4 card-v-center">
          <div class="card-body">
            <h1 class="text-center font-weight-bold mb-4 mt-3" translate>
              terms-and-conditions.title
            </h1>
            <form [formGroup]="termsAndConditionsForm">
              <div class="checkboxes row gx-0">
                <!-- user RL -->
                @if (isLr) {
                  @if (!isUserSmart) {
                    <span class="col-12">{{'terms-and-conditions.form.generic' | translate }}
                      <span class="ps-1" translate>terms-and-conditions.generic-conditions</span>
                      <!--                  <a-->
                      <!--                    class="color-orange handPointer ps-1"-->
                      <!--                    (click)="downloadGeneralConditions()"-->
                      <!--                    translate>-->
                    <!--                    terms-and-conditions.generic-conditions</a-->
                    <!--                  >-->
                    <span [innerHTML]=" 'terms-and-conditions.smart' | translate "></span>
                    @if (directChannel && !isUserSmart) {
                      {{'terms-and-conditions.order-form.final-part.del' | translate}}
                      <span class="ps-1" translate>terms-and-conditions.order-form.final-part.order</span>
                      <!--                    <a-->
                      <!--                      class="color-orange handPointer ps-1"-->
                      <!--                      (click)="downloadOrderForm()"-->
                      <!--                      translate-->
                      <!--                    >-->
                    <!--                    terms-and-conditions.order-form.final-part.order</a-->
                    <!--                    >-->
                    {{'terms-and-conditions.order-form.final-part.and' | translate}}
                  }
                  {{'terms-and-conditions.generic-conditions.final-part' | translate}}
                </span>
              }
              @if (isUserSmart) {
                <span class="col-12 whitespace-preline" translate
                  >{{'terms-and-conditions.form.generic' | translate }}
                  <span class="ps-1" translate>terms-and-conditions.generic-conditions</span>
                  <!--                  <a-->
                  <!--                    class="color-orange handPointer ps-1"-->
                  <!--                    (click)="downloadGeneralConditions()"-->
                  <!--                    translate-->
                  <!--                  >-->
                <!--                  terms-and-conditions.generic-conditions</a-->
                <!--                  >-->
                terms-and-conditions.smart
              </span>
            }
          }
          <!-- user OP -->
          @if (!isLr) {
            <span class="col-12" translate>terms-and-conditions.accept
              <span class="ps-1" translate>terms-and-conditions.generic-contract-conditions</span>
              <!--                  <a-->
              <!--                    class="color-orange handPointer ps-1"-->
              <!--                    (click)="downloadGeneralConditions()"-->
              <!--                    translate>-->
              <!--                    terms-and-conditions.generic-contract-conditions-->
            <!--                  </a>-->
          </span>
        }
      </div>
      <div class="checklist-row-tc d-flex align-items-center mt-4 mb-4">
        <div class="justify-content-start align-items-center d-flex ms-3 me-3">
          <input
            class="h-fitcontent input-with-border w-auto me-2"
            [disabled]="!generalConditionDownloaded && !orderFormDownloaded"
            formControlName="tec"
            type="checkbox"
            id="tec"
            name="tec"
            />
          <pwc-icon name="alert" class="invalid-feedback-icon"></pwc-icon>
          <span>
            <span translate>terms-and-conditions.generic-contract-checklist-pre</span>
            <a
              class="color-orange handPointer"
              (click)="downloadGeneralConditions()"
              translate
            >terms-and-conditions.generic-contract-conditions</a>
            @if (directChannel && !isUserSmart) {
              <span translate>terms-and-conditions.model-order-checklist-pre</span>
              <a
                class="color-orange handPointer"
                (click)="downloadOrderForm()"
                translate
              >terms-and-conditions.order-form-link</a>
            }
            <span class="ps-1" translate>terms-and-conditions.generic-contract-checklist-post</span>
          </span>
        </div>
      </div>
      <div class="checkboxes row gx-0 mt-3">
        @if (isLr) {
          <span class="col-12" translate>
            terms-and-conditions.explicit-lr-law-approval
          </span>
        }
        @if (!isLr) {
          <span class="col-12" translate>
            terms-and-conditions.explicit-other-law-approval
          </span>
        }
      </div>
      <div class="checklist-row-tc d-flex align-items-center mt-4 mb-4">
        <div class=" justify-content-start align-items-center  d-flex ms-3 me-3">
          <input
            class="h-fitcontent input-with-border w-auto me-2"
            formControlName="clausole"
            type="checkbox"
            id="clausole"
            name="clausole"
            />
          <pwc-icon name="alert" class="invalid-feedback-icon"></pwc-icon>
          <span translate>
            terms-and-conditions.vexatious-checklist
          </span>
        </div>
      </div>
      <div class="checkboxes align-items-center row gx-0 mt-3">
        <span class="col-12 h-fitcontent" translate>terms-and-conditions.privacy.accept
          <span class="ps-1" translate>terms-and-conditions.privacy</span>
        </span>
      </div>
      <div class="checklist-row-tc d-flex align-items-center mt-4 mb-4">
        <div class=" justify-content-start align-items-center  d-flex ms-3 me-3">
          <input
            class="h-fitcontent input-with-border w-auto me-2"
            formControlName="privacy"
            type="checkbox"
            id="privacy"
            name="privacy"
            />
          <pwc-icon name="alert" class="invalid-feedback-icon"></pwc-icon>
          <span translate>
            <span translate>terms-and-conditions.privacy-checklist-pre</span>
            <a
              class="color-orange handPointer ps-1"
              (click)="downloadPrivacy()"translate>
              terms-and-conditions.privacy
            </a>
          </span>
        </div>
      </div>
      <div class="d-flex justify-content-between flex-row mb-4">
        <button
          style="max-width: 300px"
          (click)="rejectConditions()"
          class="me-auto btn btn-primary btn-rounded btn-ghost align-self-end text-nowrap ms-4"
          translate>
          actions.cancel
        </button>
        <button
          (click)="acceptConditions()"
          [disabled]="!checkMandatoryConditions() || !buttonAcceptEnabled"
          style="max-width: 300px"
          class="btn btn-primary me-4 flex-end btn-rounded"
          translate>
          generic.accept
        </button>
      </div>
    </form>
  </div>
</div>
</div>
</div>
</div>
}
